import client from '../client';
import { toInteger } from 'lodash';
import { OrderCategory } from './Order';

export type TApiServicePackage = {
  id: number;
  code: string;
  title: string;
  features: Array<string>;
  volume_band_ids: Array<number>;
  order_categories: Array<OrderCategory>;
}

const list = (): Promise<Array<TApiServicePackage>> =>
  client.get('/service-package/').then(response => response.data);

export {
  list
};
